import { Link } from "react-router-dom";
import { Instagram, Linkedin, Facebook, ArrowUpRight } from "lucide-react";
import { NAV } from "../../content/site";
import { useSettings, whatsappLink } from "../../context/SettingsContext";

export const Footer = () => {
  const s = useSettings();
  return (
    <footer data-testid="site-footer" className="relative bg-ink text-cream grain overflow-hidden">
      <div className="container-hh pt-20 md:pt-28 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <img src="/logo-full.png" alt="Home Haven — Real Estate Development & Investment" width={1050} height={668} loading="lazy" className="h-28 md:h-36 w-auto brightness-0 invert opacity-90" data-testid="footer-logo" />
            <p className="font-serif italic text-2xl md:text-3xl font-light mt-10 text-cream/90 max-w-md">Creiamo valore trasformando gli spazi.</p>
          </div>
          <div className="md:col-span-3">
            <div className="eyebrow mb-6">Navigazione</div>
            <ul className="space-y-3">
              {NAV.slice(1).map((n) => (
                <li key={n.to}>
                  <Link to={n.to} data-testid={`footer-link-${n.to.slice(1)}`} className="text-sm text-cream/75 hover:text-gold transition-colors">{n.label}</Link>
                </li>
              ))}
              <li><Link to="/operazioni" data-testid="footer-link-operazioni" className="text-sm text-cream/75 hover:text-gold transition-colors">Operazioni Aperte</Link></li>
              <li><Link to="/diario-di-bordo" data-testid="footer-link-diario" className="text-sm text-cream/75 hover:text-gold transition-colors">Diario di bordo</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="eyebrow mb-6">Contatti</div>
            <div className="space-y-3 text-sm">
              <div className="text-cream/90">{s.company_name}</div>
              <a href={`mailto:${s.email}`} data-testid="footer-email" className="block text-cream/75 hover:text-gold transition-colors">{s.email}</a>
              <div className="text-cream/60">PEC: <a href={`mailto:${s.pec}`} className="hover:text-gold transition-colors">{s.pec}</a></div>
              {s.phone && <a href={`tel:${s.phone.replace(/\s/g, "")}`} className="block text-cream/75 hover:text-gold transition-colors">{s.phone}</a>}
              {s.address && <div className="text-cream/60">{s.address}</div>}
            </div>
            <div className="flex items-center gap-5 mt-8">
              {s.instagram && <a href={s.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="text-cream/70 hover:text-gold transition-colors"><Instagram size={20} strokeWidth={1.5} /></a>}
              {s.linkedin && <a href={s.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" data-testid="footer-linkedin" className="text-cream/70 hover:text-gold transition-colors"><Linkedin size={20} strokeWidth={1.5} /></a>}
              {s.facebook && <a href={s.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook" className="text-cream/70 hover:text-gold transition-colors"><Facebook size={20} strokeWidth={1.5} /></a>}
              {s.whatsapp_number && <a href={whatsappLink(s)} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.18em] text-cream/80 hover:text-gold transition-colors">WhatsApp <ArrowUpRight size={14} /></a>}
            </div>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-cream/10 space-y-5">
          <p data-testid="footer-legal-line" className="text-[11px] tracking-[0.05em] text-cream/45 leading-relaxed">
            {s.company_name}
            {s.registered_office && ` — Sede legale: ${s.registered_office}`}
            {s.vat_number && ` — P.IVA ${s.vat_number}`}
            {s.fiscal_code && ` — C.F. ${s.fiscal_code}`}
            {s.rea_number && ` — ${s.rea_number}`}
            {s.share_capital && ` — Capitale sociale ${s.share_capital}`}
            {` — PEC: ${s.pec}`}
          </p>
          <div className="flex flex-col md:flex-row gap-4 md:items-center justify-between text-[11px] uppercase tracking-[0.18em] text-cream/45">
            <div>© {new Date().getFullYear()} {s.company_name} — Tutti i diritti riservati</div>
            <div className="flex flex-wrap gap-x-6 gap-y-2">
              <Link to="/privacy-policy" data-testid="footer-privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
              <Link to="/cookie-policy" data-testid="footer-cookie" className="hover:text-gold transition-colors">Cookie Policy</Link>
              <Link to="/termini-e-condizioni" data-testid="footer-terms" className="hover:text-gold transition-colors">Termini e Condizioni</Link>
              <button type="button" data-testid="footer-cookie-prefs" onClick={() => window.dispatchEvent(new Event("hh-open-cookie-prefs"))} className="uppercase hover:text-gold transition-colors">Preferenze cookie</button>
              <Link to="/admin/login" data-testid="footer-admin" className="hover:text-gold transition-colors">Area riservata</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
